export const APP_NAMESPACE = 'app'
export const APP_CURRENT_CONTENT = 'currentContent'
export const APP_CURRENT_CONTENT_ID = 'currentContentId'
export const APP_CURRENT_CONTENT_CLASS = 'currentContentClass'
export const APP_CURRENT_CONTENT_NAME = 'currentContentName'
export const APP_CURRENT_MENU = 'currentMenu'
export const APP_CURRENT_LANGUAGE = 'currentLanguage'
export const APP_MENU = 'getMenu'
export const APP_DETAIL_SHOWN = 'isDetailShown'
export const APP_DETAIL_CONTENT = 'detailContent'
export const APP_PACKAGE_VERSION = 'packageVersion'
export const APP_LOADING = 'appLoading'
export const APP_VISUALS = 'visuals'
export const APP_DETAIL_TITLE = 'detailTitle'
export const APP_GENERAL_SIDEBAR = 'generalSidebar'

export const APP_DEFAULT_LANGUAGE = 'ca_ES'



// WEBPACK FOOTER //
// ./src/store/actions/app.js